import React from "react";
import Header from "../Header";
import Banner from "../Banner";

export default function HeaderAndBanner() {
  return (
    <div>
      <Header />
      <Banner />
    </div>
  );
}
